import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PathNotFound from '../views/404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '4th Anniversary | リネージュ2 レボリューション', description: 'リネレボ4周年特設サイト。拡張パック〈アンタラスの憤怒〉実装や4周年記念生放送の情報、リネレボ名刺メーカーなど、リネレボ4周年を記念したイベント・キャンペーン情報をお届けします！', image: 'https://l2.netmarble.jp/event/4th-anniversary/img/ogp.jpg' }
  }, {
    path: '/antaras',
    name: 'Antaras',
    component: () => import('../views/Antaras.vue'),
    meta: { title: 'アンタラスの憤怒 | リネージュ2 レボリューション', description: 'リネレボ4周年特設サイト。拡張パック〈アンタラスの憤怒〉実装や4周年記念生放送の情報、リネレボ名刺メーカーなど、リネレボ4周年を記念したイベント・キャンペーン情報をお届けします！', image: 'https://l2.netmarble.jp/event/4th-anniversary/img/ogp-antaras.jpg' }
  },
  { path: '/:catchAll(.*)', name:'PathNotFound', component: PathNotFound, }
]

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 }
  }
};

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/event/4th-anniversary',
  routes,
  scrollBehavior
})

export default router
